import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackMetaEvent } from './MetaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  text = 'Accedé ahora al Mega Pack',
  className = '',
  onClick,
  variant = 'primary',
  href
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-bold rounded-full transition-all duration-300 shadow-lg group text-center';
  const variants = {
    primary: 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white hover:from-yellow-500 hover:to-orange-500 hover:shadow-xl hover:-translate-y-1',
    secondary: 'bg-white text-orange-500 border-2 border-orange-100 hover:bg-orange-50 hover:border-orange-200 hover:-translate-y-1'
  };
  const content = <span className="flex items-center justify-center flex-wrap gap-2" data-id="element-31">
      <span data-id="element-32">{text}</span>
      <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" data-id="element-33" />
    </span>;
  const isInternalLink = href?.startsWith('#');
  const handleClick = () => {
    if (href?.includes('/checkout')) {
      trackMetaEvent('InitiateCheckout', {
        content_name: 'Mega Pack de Recursos Docentes',
        content_type: 'product',
        value: 21990,
        currency: 'ARS'
      });
    }
    onClick?.();
  };
  if (href) {
    return <motion.a whileTap={{
      scale: 0.98
    }} href={href} target={isInternalLink ? undefined : '_blank'} rel={isInternalLink ? undefined : 'noopener noreferrer'} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={handleClick} data-id="element-34">
        {content}
      </motion.a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-35">
      {content}
    </motion.button>;
}